module.exports = __webpack_public_path__ + "static/media/feature_bg.f3de57c4.png";